import { db } from './../../config/Fire';

export const UPDATE_PROMOTIONS = 'UPDATE_PROMOTIONS';
export const SAVING_PROMOTIONS = 'SAVING_PROMOTIONS';
export const SAVED_PROMOTIONS = 'SAVED_PROMOTIONS';

const setPromotionsUpdated = payload => ({ type: UPDATE_PROMOTIONS, payload });
export const setSavingPromotions = payload => ({ type: SAVING_PROMOTIONS, payload });
export const setSavedPromotions = payload => ({ type: SAVED_PROMOTIONS, payload });

export const updatePromotions = payload => {
    return dispatch => {
        var isSavingPromotions = true;
        dispatch(setSavingPromotions(isSavingPromotions));
        const { promotions } = payload;
        return db.ref().update({
            promotions: promotions
        })
        .then(() => {
            //console.log("getRestaurant: " + JSON.stringify(restaurant));
            dispatch(setPromotionsUpdated(promotions));
            dispatch(setSavingPromotions(isSavingPromotions = false));
            var isSavedPromotions = true;
            dispatch(setSavedPromotions(isSavedPromotions));
        })
        .catch(err => {
            console.log("not found save data");
            dispatch(setSavingPromotions(isSavingPromotions = false));
        });
    };
};